import {
  MODEL_CAPABILITIES,
  VIDEO_MODEL_CANONICAL_ID,
} from '../../generated/modelCapabilities'

function canonicalVideoModel(model: string): string {
  return VIDEO_MODEL_CANONICAL_ID[model] ?? model
}

/** Convert an exact provider value to its generic project-quality label. */
export function projectQualityForVideoResolution(model: string, resolution: string): string {
  const capabilities = MODEL_CAPABILITIES[canonicalVideoModel(model)]
  if (!capabilities) return resolution
  const mapped = Object.entries(capabilities.providerResolutionToProjectQuality ?? {}).find(
    ([providerResolution]) => providerResolution.toLowerCase() === resolution.toLowerCase(),
  )
  return mapped?.[1] ?? resolution
}

/** Resolve one generic project quality to the selected model's exact provider value. */
export function videoResolutionForProjectQuality(model: string, projectQuality: string): string {
  const capabilities = MODEL_CAPABILITIES[canonicalVideoModel(model)]
  if (!capabilities) return projectQuality
  const canonical = capabilities.resolutions.find(
    (resolution) => resolution.toLowerCase() === projectQuality.toLowerCase(),
  )
  if (canonical) return canonical
  const mapped = Object.entries(capabilities.providerResolutionToProjectQuality ?? {}).find(
    ([, quality]) => quality.toLowerCase() === projectQuality.toLowerCase(),
  )
  return mapped?.[0] ?? projectQuality
}
